<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('attrValueManage.queryCondition') }}</span>
          </div>
          <div class="text-left">
            <el-form :model="attrValueManageInfo.conditions" class="search-form text-left" inline>
              <el-form-item>
                <el-input v-model="attrValueManageInfo.conditions.value" :placeholder="$t('attrValueManage.inputValue')"
                  clearable></el-input>
              </el-form-item>

              <el-form-item>
                <el-select v-model="attrValueManageInfo.conditions.valueShow"
                  :placeholder="$t('attrValueManage.selectDisplay')" style="width:100%" clearable>
                  <el-option :label="$t('attrValueManage.yes')" value="Y"></el-option>
                  <el-option :label="$t('attrValueManage.no')" value="N"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item>
                <el-input v-model="attrValueManageInfo.conditions.valueName"
                  :placeholder="$t('attrValueManage.inputValueName')" clearable></el-input>
              </el-form-item>

              <el-button type="primary" size="small" @click="_queryAttrValueMethod()">
                <i class="el-icon-search"></i>
                {{ $t('attrValueManage.query') }}
              </el-button>
              <el-button type="primary" size="small" @click="_resetAttrValueMethod()">
                <i class="el-icon-refresh"></i>
                {{ $t('attrValueManage.reset') }}
              </el-button>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row >
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('attrValueManage.attributeValue') }}</span>
            <div style="float:right">
              <el-button type="primary" size="small" @click="_openAddAttrValueModal()">
                <i class="el-icon-plus"></i>
                {{ $t('attrValueManage.add') }}
              </el-button>
              <el-button type="default" size="small" @click="_goBack()">
                {{ $t('attrValueManage.back') }}
              </el-button>
            </div>
          </div>
          <div class="card-body">
            <el-table :data="attrValueManageInfo.attrValues" border style="width:100%">
              <el-table-column prop="valueName" :label="$t('attrValueManage.valueName')"
                align="center"></el-table-column>
              <el-table-column prop="value" :label="$t('attrValueManage.value')" align="center"></el-table-column>
              <el-table-column prop="valueId" :label="$t('attrValueManage.valueId')" align="center"></el-table-column>
              <el-table-column prop="valueShow" :label="$t('attrValueManage.display')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.valueShow == 'Y' ? $t('attrValueManage.yes') : $t('attrValueManage.no') }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('attrValueManage.operation')" align="center" width="200">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="_openEditAttrValueModel(scope.row)">
                    {{ $t('attrValueManage.edit') }}
                  </el-button>
                  <el-button type="text" size="small" @click="_openDeleteAttrValueModel(scope.row)">
                    {{ $t('attrValueManage.delete') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination @current-change="handleCurrentChange" :current-page="attrValueManageInfo.conditions.page"
              :page-size="attrValueManageInfo.conditions.row" layout="total, prev, pager, next, jumper"
              :total="attrValueManageInfo.total" style="margin-top:20px;text-align:right"></el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <add-attr-value ref="addAttrValue"></add-attr-value>
    <edit-attr-value ref="editAttrValue"></edit-attr-value>
    <delete-attr-value ref="deleteAttrValue"></delete-attr-value>
  </div>
</template>

<script>
import { listAttrValue } from '@/api/dev/attrValueApi'
import AddAttrValue from '@/components/dev/addAttrValue/addAttrValue'
import EditAttrValue from '@/components/dev/editAttrValue/editAttrValue'
import DeleteAttrValue from '@/components/dev/deleteAttrValue/deleteAttrValue'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AttrValueManage',
  components: {
    AddAttrValue,
    EditAttrValue,
    DeleteAttrValue
  },
  data() {
    return {
      attrValueManageInfo: {
        attrValues: [],
        total: 0,
        conditions: {
          value: '',
          valueShow: '',
          valueName: '',
          specId: '',
          domain: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.attrValueManageInfo.conditions.specId = this.$route.query.specId
    this.attrValueManageInfo.conditions.domain = this.$route.query.domain
    this._listAttrValues(1, 10)
    console.log(getShopId)
  },
  methods: {
    async _listAttrValues(page, rows) {
      this.attrValueManageInfo.conditions.page = page
      this.attrValueManageInfo.conditions.row = rows

      try {
        const res = await listAttrValue(this.attrValueManageInfo.conditions)
        this.attrValueManageInfo.attrValues = res.data
        this.attrValueManageInfo.total = res.total
        this.attrValueManageInfo.conditions.page = res.currentPage
      } catch (error) {
        console.error('获取属性值列表失败:', error)
      }
    },
    _openAddAttrValueModal() {
      this.$refs.addAttrValue.open({
        specId: this.attrValueManageInfo.conditions.specId
      })
    },
    _openEditAttrValueModel(row) {
      this.$refs.editAttrValue.open(row)
    },
    _openDeleteAttrValueModel(row) {
      this.$refs.deleteAttrValue.open(row)
    },
    _queryAttrValueMethod() {
      this._listAttrValues(1, 10)
    },
    _resetAttrValueMethod() {
      this.attrValueManageInfo.conditions.value = ''
      this.attrValueManageInfo.conditions.valueShow = ''
      this.attrValueManageInfo.conditions.valueName = ''
      this._listAttrValues(1, 10)
    },
    handleCurrentChange(val) {
      this._listAttrValues(val, 10)
    },
    _goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.card-body {
  padding: 20px;
}
</style>